<!-- 这是下载页面 -->
<template>
    <div class="companyProfile en_body">
        <div class="enterprise_banner wow animated fadeIn animated" style="visibility: visible; animation-name: fadeIn;">
            <img src="../images/banner2.png" alt="">
        </div>
        <div class="enterprise_con inner clearfix wow animated fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
            <div class="enterprise_con_nav">
                <a href="javascript:;" @click="clickConNav(index)" v-for="(item, index) in conNav" :key="index" :class="{'on': item.active}">{{item.text}}</a>
            </div>
            <div v-for="(item, index) in enterpriseCon" :key="index" :class="{'enterprise_con_txt': true, 'active': conNav[index].active}">
                <div class="enterprise_con_tit">{{item.title}}</div>
                <div class="enterprise_con_txt_con">
                    <div v-for="(sub, index2) in item.content" :key="index2">
                        <h4 v-if="sub.title">{{sub.title}}</h4>
                        <p v-if="sub.text">{{sub.text}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { WOW } from 'wowjs'
import config from '../config'

const conNav = []
config.enterpriseCon.map(item => {
    conNav.push({
        text: item.title,
        active: false
    })
})
conNav[0].active = true

export default {
    data () {
        return {
            config,
            conNav
        }
    },
    computed: {
        tabIndex () {
            return this.$route.query.tab || 1
        },
        enterpriseCon () {
            return config.enterpriseCon
        }
    },
    watch: {
        tabIndex (newVal, oldVal) {
            this.clickConNav(newVal - 1)
        }
    },
    methods: {
        clickConNav ($index) {
            this.conNav.map((item, index) => {
                item.active = $index === index
            })
        }
    },
    mounted () {
		this.$nextTick(() => { // 在dom渲染完后,再执行动画
			var wow = new WOW({
			  	live: false
			})
			wow.init()
		})
        this.clickConNav(this.tabIndex - 1) 
	}
}
</script>

<style scoped></style>
